<div class="park-tickets">
  <h4 class="park-tickets-title">Seleccionar Tickets</h4>

  <div class="park-ticket-grid">
    <div class="park-ticket" *ngFor="let t of types; trackBy: trackByType" [class.selected]="t.type === selectedType"
         [style.border-color]="t.type === selectedType ? buttonColorActive : null">
      <!-- Ilustración del tipo de ticket: imagen fija (Disney) o pines dibujados -->
      <div class="park-ticket-art">
        <img *ngIf="t.image" [src]="t.image" alt="" aria-hidden="true">
        <svg *ngIf="!t.image" viewBox="0 0 240 130" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
          <rect width="240" height="130" fill="#dcebf2"></rect>
          <path d="M0 100 Q60 78 120 92 T240 84 L240 130 L0 130 Z" fill="#b3e04f"></path>
          <ellipse cx="30" cy="108" rx="16" ry="7" fill="#8bc43a"></ellipse>
          <ellipse cx="205" cy="104" rx="20" ry="8" fill="#8bc43a"></ellipse>
          <g *ngFor="let p of t.pins" [attr.transform]="'translate(' + p.x + ',' + p.y + ') scale(' + p.scale + ')'">
            <path d="M0 0 C-17 0 -26 12 -26 26 C-26 44 0 66 0 66 C0 66 26 44 26 26 C26 12 17 0 0 0 Z"
                  [attr.fill]="p.color" stroke="#0b2b3c" stroke-width="3"></path>
            <circle cx="0" cy="26" r="15" fill="#fff"></circle>
            <ng-container [ngSwitch]="p.icon">
              <g *ngSwitchCase="'mickey'" [attr.fill]="p.color">
                <circle cx="0" cy="29" r="6.5"></circle>
                <circle cx="-8" cy="20" r="4.5"></circle>
                <circle cx="8" cy="20" r="4.5"></circle>
              </g>
              <path *ngSwitchCase="'castle'" [attr.fill]="p.color" d="M-8 36 V24 L-5 18 L-2 24 V14 L0 10 L2 14 V24 L5 18 L8 24 V36 Z"></path>
              <g *ngSwitchCase="'tree'" [attr.fill]="p.color">
                <circle cx="0" cy="22" r="8"></circle>
                <rect x="-1.5" y="28" width="3" height="8"></rect>
              </g>
              <g *ngSwitchCase="'ring'" fill="none" [attr.stroke]="p.color" stroke-width="3.5">
                <circle cx="0" cy="26" r="8"></circle>
              </g>
              <path *ngSwitchCase="'fort'" [attr.fill]="p.color" d="M-9 36 V20 H-5 V24 H-2 V20 H2 V24 H5 V20 H9 V36 Z"></path>
              <g *ngSwitchCase="'lifebuoy'" fill="none" [attr.stroke]="p.color" stroke-width="4">
                <circle cx="0" cy="26" r="8"></circle>
              </g>
            </ng-container>
          </g>
        </svg>
      </div>

      <div class="park-ticket-body">
        <p class="park-ticket-name">{{ t.title }}</p>
        <p class="park-ticket-desc" [class.expanded]="expanded[t.type]">{{ t.description }}</p>
        <button type="button" class="park-ticket-more" (click)="toggle(t.type)">
          {{ expanded[t.type] ? 'Ver Menos' : '... Ver Más' }}
        </button>
      </div>

      <div class="park-ticket-pax">
        <div class="park-ticket-pax-col">
          <strong>Adultos x{{ adults }}</strong>
          <span>+ de 10 años</span>
        </div>
        <ng-container *ngIf="children > 0">
          <span class="park-ticket-pax-sep"></span>
          <div class="park-ticket-pax-col">
            <strong>Niños x{{ children }}</strong>
            <span>de 3 a 9 años</span>
          </div>
        </ng-container>
      </div>

      <div class="park-ticket-footer">
        <div>
          <small>Desde {{ t.fromDays }} {{ t.fromDays === 1 ? 'día' : 'días' }}</small>
          <p class="park-ticket-amount">
            {{ currencyAgency?.code }} {{ t.fromPrice | currencyConverterPure: sourceCurrency: currencyAgency?.code: currencies | number: '1.2-2' }}
          </p>
          <p class="park-ticket-amount-src" *ngIf="sourceCurrency !== currencyAgency?.code">
            {{ sourceCurrency }} {{ t.fromPrice | number: '1.2-2' }}
          </p>
        </div>
        <button type="button" class="park-ticket-btn" [style.background-color]="buttonColorActive" (click)="choose.emit(t.type)">
          {{ t.type === selectedType ? 'Seleccionado' : 'Seleccionar' }}
        </button>
      </div>
    </div>

    <!-- Solo hotel, sin tickets -->
    <div class="park-ticket" *ngIf="allowNone" [class.selected]="selectedType === 'none'"
         [style.border-color]="selectedType === 'none' ? buttonColorActive : null">
      <div class="park-ticket-art">
        <svg viewBox="0 0 240 130" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
          <rect width="240" height="130" fill="#e8edf0"></rect>
          <path d="M0 100 Q60 78 120 92 T240 84 L240 130 L0 130 Z" fill="#cfd8dc"></path>
          <path d="M80 92 V66 L120 40 L160 66 V92 Z" fill="#fff" stroke="#90a4ae" stroke-width="3"></path>
          <rect x="110" y="70" width="20" height="22" fill="#90a4ae"></rect>
        </svg>
      </div>
      <div class="park-ticket-body">
        <p class="park-ticket-name">Solo hotel</p>
        <p class="park-ticket-desc expanded">Reserva únicamente la habitación, sin tickets de entrada a los parques.</p>
      </div>
      <div class="park-ticket-footer">
        <p class="park-ticket-amount">Sin costo adicional</p>
        <button type="button" class="park-ticket-btn" [style.background-color]="buttonColorActive" (click)="choose.emit('none')">
          {{ selectedType === 'none' ? 'Seleccionado' : 'Seleccionar' }}
        </button>
      </div>
    </div>
  </div>
</div>
